var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-popup"},[_c('div',{ref:"reference",staticClass:"n-popup-reference"},[_vm._t("reference",function(){return [_vm._v("(reference slot missing)")]})],2),_vm._v(" "),_c('div',{ref:"popup",staticClass:"n-popup-popup"},[_vm._t("popup",function(){return [_vm._v("(popup slot missing)")]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3680eae0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/npopup/NPopup.vue
// module id = null
// module chunks = 